import React from 'react';

const SectionLabel = ({ title }) => {
  return (
    <div className="marginY10">
      <h2 className="h2">{title}</h2>
    </div>
  );
};

export default SectionLabel;
